import React, { useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';
import { useTranslate } from '../../../core/translate';
import SvgIcon from '../../../core/icons/SvgIcon';
import { onCloseModal } from '../../components/modal/Modal';
import { combineClassNames } from '../../../core/css';

export const ToastModalContent = ({ closeModal, children }) => {
  const translate = useTranslate();
  const closeLabel = translate('byo.page.general.close');

  return (
    <div className="toast-modal-content">
      <div className="toast-modal-content__inner">
        <button
          className="toast-modal-content__close-button stat-button-close"
          data-dtm="disclosure"
          onClick={closeModal}
          aria-label={closeLabel}>
          <SvgIcon name="close" alt={closeLabel} />
        </button>
        {children}
      </div>
    </div>
  );
};

const ToastModal = ({
  useTimeout = true,
  setExpiration = () => {},
  onClose,
  modalClassName,
  modalOverlayClassName,
  children,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(true);

  const timeout = 500;
  const closeModal = () => {
    setIsOpen(false);
    useTimeout && setExpiration();
    onCloseModal(onClose, timeout);
  };

  const modalIsOpenRef = useRef(modalIsOpen);
  modalIsOpenRef.current = modalIsOpen;

  /* The timer below closes the modal after 15 seconds if the modal has not been closed by the user.
    I am following this pattern for the timer below: https://upmostly.com/tutorials/settimeout-in-react-components-using-hooks
     */

  useEffect(() => {
    if (useTimeout) {
      const timer = setTimeout(() => {
        if (modalIsOpenRef.current) closeModal();
      }, 15000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <ReactModal
      isOpen={modalIsOpen}
      closeTimeoutMS={timeout}
      className={combineClassNames(
        'reveal-toast-modal',
        modalClassName,
        isClosing ? 'close-modal' : ''
      )}
      overlayClassName={combineClassNames(
        'toast-modal__reveal-overlay',
        modalOverlayClassName
      )}
      appElement={document.getElementById('byo-web-ui')}
      onRequestClose={() => setIsClosing(true, closeModal())}
      bodyOpenClassName="ReactModal__Body--open-with-overflow">
      {children({ setIsClosing, closeModal })}
    </ReactModal>
  );
};

export default ToastModal;
